import {
  BackOrderCommentResponse,
  BackOrderHistoryResponse,
  BackOrderInfo,
  BackOrderSubscriptionType,
  ClosetUserCount,
} from 'types/api/backorder';
import { coreApiWithInterceptors } from 'services/axiosInterceptor';
import { AxiosError } from 'axios';

const backOrderUrl = '/closet/backorder';

export const getBackOrderInfo = async (params: { groupId: string }): Promise<BackOrderInfo> => {
  const { data } = await coreApiWithInterceptors.get(`${backOrderUrl}/info`, { params });
  return data;
};

export const putStartDate = async (params: {
  subscriptionId: number;
  startDate: string;
  comment: string;
}): Promise<void> => {
  await coreApiWithInterceptors.put(`${backOrderUrl}/subscription/startdate`, {
    ...params,
  });
};

export const putEndDate = async (params: {
  subscriptionId: number;
  endDate: string;
  comment: string;
}): Promise<void> => {
  await coreApiWithInterceptors.put(`${backOrderUrl}/subscription/enddate`, {
    ...params,
  });
};

export const initCredit = async (params: { groupId: string; comment: string }): Promise<void> => {
  await coreApiWithInterceptors.post(`${backOrderUrl}/credit/init`, {
    ...params,
  });
};

export const adjustCredit = async (params: {
  groupId: string;
  currentCredit: number;
  additionalCredit: number;
  comment: string;
}): Promise<void | AxiosError> => {
  return await coreApiWithInterceptors.post(`${backOrderUrl}/credit/adjust`, {
    ...params,
  });
};

export const downgradeToFree = async (params: {
  subscriptionId: number;
  comment: string;
}): Promise<void | AxiosError> => {
  return await coreApiWithInterceptors.post(`${backOrderUrl}/subscription/downgrade`, {
    ...params,
  });
};

export const subscribeBackOrder = async (params: {
  groupId: string;
  subscription: {
    plan: BackOrderSubscriptionType;
    startDate: string;
    endDate?: string;
    credit: number;
  };
  comment: string;
}): Promise<void | AxiosError> => {
  return await coreApiWithInterceptors.post(`${backOrderUrl}/subscription`, {
    ...params,
  });
};

export const deleteBackOrder = async (params: {
  subscriptionId: number;
  comment: string;
}): Promise<void> => {
  return await coreApiWithInterceptors.delete(`${backOrderUrl}/subscription`, { data: params });
};

export const getBackOrderHistories = async ({
  pageSize = 10,
  ...rest
}: {
  groupId: string;
  pageNo: number;
  pageSize?: number;
}): Promise<BackOrderHistoryResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${backOrderUrl}/histories`, {
    params: { pageSize, ...rest },
  });
  return data;
};

export const getBackOrderComments = async ({
  pageSize = 10,
  ...rest
}: {
  groupId: string;
  pageNo: number;
  pageSize?: number;
}): Promise<BackOrderCommentResponse> => {
  const { data } = await coreApiWithInterceptors.get(`${backOrderUrl}/comments`, {
    params: { pageSize, ...rest },
  });
  return data;
};

export const getClosetUserCount = async (params: { groupId: string }): Promise<ClosetUserCount> => {
  const { data } = await coreApiWithInterceptors.get(`${backOrderUrl}/subscription/credit/calc`, {
    params,
  });
  return data;
};
